import triyoAPI from './triyo';
import { config } from '../../util/axios-config';

export const GetAllNotificationByUserNew = (data) => {
    return triyoAPI.post(`/notifications/GetAllNotificationByUser`, data, config("POST"));
}

export const MarkAllNotificationAsReadByUserNew = () => {
    return triyoAPI.get(`/notifications/MarkAllNotificationsAsRead`, config());
}

export const MarkNotificationAsReadAPI = (id) => {
    return triyoAPI.get(`/notifications/ClickNotification?Id=`+id, config());
}
